import { BaseApiClient } from './base-client';

export interface PublicShareLink {
  id: number;
  token: string;
  service_id: number;
  share_path: string;
  created_by: number;
  created_at: string;
  expires_at: string;
  has_password: boolean;
  download_limit?: number;
  download_count: number;
  allowed_ips?: string[];
  denied_ips?: string[];
  is_active: boolean;
  is_permanent: boolean;
  share_url: string;
  last_accessed?: string;
}

export interface CreateShareRequest {
  share_path: string;
  expires_in_hours?: number | null;  // null for permanent
  password?: string;
  download_limit?: number;
  allowed_ips?: string[];
  denied_ips?: string[];
}

export interface ShareAccessLog {
  id: number;
  share_id: number;
  accessed_at: string;
  ip_address: string;
  user_agent: string;
  file_path?: string;
  download_size?: number;
}

export class SharesApiClient extends BaseApiClient {

  async createShare(serviceId: number, data: CreateShareRequest): Promise<PublicShareLink> {
    try {
      return await this.post<PublicShareLink>(`/api/v1/shares/${serviceId}/shares`, data);
    } catch (error: any) {
      throw error.response?.data || error;
    }
  }

  async listShares(serviceId: number): Promise<PublicShareLink[]> {
    try {
      const shares = await this.get<PublicShareLink[]>(`/api/v1/shares/${serviceId}/shares`);
      return shares || [];
    } catch (error: any) {
      throw error.response?.data || error;
    }
  }

  async deleteShare(serviceId: number, shareId: number): Promise<void> {
    try {
      await this.delete(`/api/v1/shares/${serviceId}/shares/${shareId}`);
    } catch (error: any) {
      throw error.response?.data || error;
    }
  }

  async revokeShare(serviceId: number, shareId: number): Promise<void> {
    try {
      await this.post(`/api/v1/shares/${serviceId}/shares/${shareId}/revoke`, {});
    } catch (error: any) {
      throw error.response?.data || error;
    }
  }

  async getShareAccessLogs(serviceId: number, shareId: number): Promise<ShareAccessLog[]> {
    try {
      const logs = await this.get<ShareAccessLog[]>(`/api/v1/shares/${serviceId}/shares/${shareId}/access-logs`);
      return logs || [];
    } catch (error: any) {
      throw error.response?.data || error;
    }
  }
}